import React from 'react'
import styled from 'styled-components'
import { ISchoolListingItemProp } from '../../SchoolListingGroups/SchoolListingGroup/SchoolListingItemProp'
import { SchoolListingItem } from '../../SchoolListingGroups/SchoolListingGroup/SchoolListingItem'

const StyledSchoolListingViewAllModalItem = styled(SchoolListingItem)`
  width: 100%;
  margin-left: 0;
  margin-right: 0;
`

interface ISchoolListingViewAllModalItemProps {
  schoolCoords: Array<number>
  listing: ISchoolListingItemProp
}

const SchoolListingViewAllModalItem: React.FC<ISchoolListingViewAllModalItemProps> =
  ({ schoolCoords, listing }) => (
    <StyledSchoolListingViewAllModalItem
      schoolCoords={schoolCoords}
      listing={listing}
    />
  )

export { SchoolListingViewAllModalItem }
